import tldjs from 'tldjs';
const getDomain = () => {
  let tld = tldjs;
  if (process.env.NODE_ENV === `development` || process.env.NODE_ENV === `integration`) {
    tld = tldjs.fromUserSettings({
      validHosts: ['localhost'],
    });
  }
  return tld.getDomain(window.location.toString());
};
export default getDomain;
